import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import Copyright from './FooterCopyright';
import Section from './FooterSection';

const HeaderRow = () => {
    return (
        <Row>
            <Col>
                <hr />
            </Col>
        </Row>
    );
};

const FooterContent = ({ content }) => {
    return (
        <footer className="row footer-container no-gutters">
            <Col>
                <Container>

                    <Row className="footer-row d-none d-lg-flex">
                        {content.sections.map((section, i) => (
                            <Section key={section.id} id={`section-${i}`} section={section} />
                        ))}
                    </Row>

                    <HeaderRow />

                    <Row className="footer-row">
                        <Col className="footer-copyright">
                            <Copyright />
                        </Col>
                    </Row>
                </Container>
            </Col>
        </footer>
    );
};

FooterContent.propTypes = {
    content: PropTypes.shape({
        sections: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                title: PropTypes.string,
                text: PropTypes.string,
                links: PropTypes.arrayOf(
                    PropTypes.shape({
                        href: PropTypes.string.isRequired,
                        title: PropTypes.string,
                        external: PropTypes.bool,
                    }),
                ),
            }),
        ),
    }).isRequired,
};

export default React.memo(FooterContent);
